import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import { ReplyProps, ResponseFailedReason } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';

import 'reviews2/feed/review-yeti/reply/failed/ReplyFailedReason.scss';

export const ReplyFailedReason: FunctionComponent<ReplyProps> = ({ context, reply }) => {
    const { t } = useTranslation('reviews2');

    if (!reply.responseFailedReason) {
        return null;
    }

    return (
        <div className="r4e-reply-failed-reason">
            <i className="icon-exclamation-triangle" />{' '}
            {reply.responseFailedReason === ResponseFailedReason.ClientRequest && t('FAILED_REASON_CLIENT_REQUEST')}
            {reply.responseFailedReason === ResponseFailedReason.CredentialsMissing &&
                t('FAILED_REASON_CREDENTIALS_MISSING')}
            {reply.responseFailedReason === ResponseFailedReason.CredentialsInvalid &&
                t('FAILED_REASON_CREDENTIALS_INVALID')}
            {reply.responseFailedReason === ResponseFailedReason.ReviewDeleted && t('FAILED_REASON_REVIEW_MISSING')}
            {reply.responseFailedReason === ResponseFailedReason.Other && reply.responseFailedReasonExplanation}
        </div>
    );
};
